import { render, staticRenderFns } from "./cc.vue?vue&type=template&id=6f1ca374&scoped=true"
import script from "./cc.vue?vue&type=script&lang=js"
export * from "./cc.vue?vue&type=script&lang=js"
import style0 from "./cc.vue?vue&type=style&index=0&id=6f1ca374&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ca374",
  null
  
)

export default component.exports